import React, { ReactElement } from 'react';
import { Col, FlexboxGrid, Row, Text } from 'rsuite';
import { convertNumberToCurrency } from '../../../common/utils';
import LabelWithInfoIcon from '../../common/LabelWithInfoIcon';

interface TaxBreakdownItemProps {
  title: string;
  value: number;
  bold?: boolean;
  infoText?: string;
}

export const TaxBreakdownItem = ({
  title = '',
  value,
  bold,
  infoText,
}: TaxBreakdownItemProps): ReactElement => {
  return (
    <FlexboxGrid.Item
      data-testid={`taxbreakdown-${title}`}
      colspan={24}
      as={Row}
      style={{
        paddingBottom: '4px',
        fontWeight: bold ? 'bold' : 'normal',
      }}
    >
      <FlexboxGrid>
        <FlexboxGrid.Item
          colspan={20}
          as={Col}
        >
          <LabelWithInfoIcon
            label={title}
            infoText={infoText}
            isBold={bold}
          />
        </FlexboxGrid.Item>
        <FlexboxGrid.Item
          colspan={4}
          as={Col}
        >
          <Text style={{ textAlign: 'right' }}>
            {convertNumberToCurrency(value)}
          </Text>
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </FlexboxGrid.Item>
  );
};
